import { NextRouter } from 'next/router';

import { useCallback, useEffect } from 'react';

import { ParsedUrlQuery } from 'querystring';

const CATEGORY = '/[slug]';

const usePageViewEvent = (router: NextRouter): void => {
  const getContentCategory = useCallback((route: string, query: ParsedUrlQuery) => {
    if (CATEGORY === route) {
      const category = query.slug as string;

      return category;
    }
    return route;
  }, []);

  const handleRouteChange = useCallback(() => {
    // @ts-ignore
    const { dataLayer } = window;

    if (dataLayer) {
      const { route, query } = router;
      const event = {
        event: 'view_content',
        content_category: getContentCategory(route, query),
      };
      const path = window.location.href;

      if (path.includes('localhost')) {
        console.warn('view_content ', event);
      } else {
        dataLayer.push(event);
      }
    }
  }, [getContentCategory, router]);

  useEffect(() => {
    handleRouteChange();

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [handleRouteChange, router]);
};

export default usePageViewEvent;
